/* cSpell:disable */
import { FooterConfig } from '@tenants/types/tenant';
import { LOCALE_EXP_REALTY_US_PATHS } from 'types/locales';

export function createFooterConfig(): FooterConfig {
  return {
    footerColumns: {
      column1: [
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_EXPLOREEXP_LABEL,
          link: '/explore-exp',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_FINDAGENT_LABEL,
          link: '/agents-search',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_JOINEXP_LABEL,
          link: 'https://join.exprealty.com',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_INVESTORRELATIONS_LABEL,
          link: 'https://expworldholdings.com/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_COMPANYCAREERS_LABEL,
          link: 'https://expworldholdings.com/careers/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_HOMEGUIDES_LABEL,
          link: 'https://exprealty.com/guides/',
          isAnchor: true,
          target: '_blank',
        },
      ],
      column2: [
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_EXPLIFE_LABEL,
          link: 'https://life.exprealty.com/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_ZOOCASA_LABEL,
          link: 'https://zoocasa.com/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_SUCCESS_LABEL,
          link: 'https://www.success.com/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_REVENOS_LABEL,
          link: 'https://revenos.com/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_COMMERCIAL_LABEL,
          link: 'https://expcommercial.com/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LUXURY_LABEL,
          link: 'https://expluxury.com/?tl=en',
          target: 'blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_ACCESSIBILITY_LABEL,
          link: '/accessibility',
          isAnchor: true,
          target: '_blank',
        },
      ],
      column3: [
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_TERMSANDCONDITIONS_LABEL,
          link: 'https://expworldholdings.com/terms-of-service/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_PRIVACYRIGHTSREQUEST_LABEL,
          link: 'https://submit-irm.trustarc.com/services/validation/e6d7516d-df9c-4404-bd9f-21a2f0d2a6a4/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_PRIVACYPOLICY_LABEL,
          link: 'https://expworldholdings.com/privacy-policy/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_COOKIEPOLICY_LABEL,
          link: 'https://expworldholdings.com/cookie-policy/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_BRANDGUIDELINES_LABEL,
          link: 'https://join.exprealty.com/brand/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_HELP_LABEL,
          link: 'https://searchhelp.exprealty.com/hc/en-us/',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_SITEMAP_LABEL,
          link: '/sitemap',
          isAnchor: true,
          target: '_blank',
        },
      ],
      bottom: [
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_COPYRIGHT_LABEL,
          },
        ],
        [
          {
            label: ' ',
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_DMCA_LABEL,
            link: '/dmca',
            target: '_blank',
            isAnchor: true,
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_PROTECTED,
          },
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_PRIVACYPOLICY,
            link: 'https://policies.google.com/privacy',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_AND,
          },
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_TERMSOFSERVICE,
            link: 'https://policies.google.com/terms',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_APPLY,
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_FAIRHOUSING_LABEL,
            link: '/fair-housing-and-reasonable-accommodations',
            target: '_blank',
            isAnchor: true,
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_MLSCOMPLIANCE_LABEL,
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_TEXAS,
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_TEXASBROKERAGESERVICES_LABEL,
            link: 'https://dtzulyujzhqiu.cloudfront.net/expcorporate377/compliance/tx/entity/377_30621_iabs.pdf',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_TEXASCONSUMERPROTECTION_LABEL,
            link: 'https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-4-1_1.pdf',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_FAIRHOUSING_LABEL,
          },
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_FAIRHOUSING_NOTICE,
            link: 'https://dos.ny.gov/fair-housing',
            isAnchor: true,
            target: '_blank',
          },
          {
            label: ' →',
            link: 'https://dos.ny.gov/system/files/documents/2021/08/fairhousingnotice.pdf',
            target: '_blank',
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_STANDARDIZEDOPERATINGPROCEDURE_LABEL,
          },
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_FAIRHOUSING_LEARNMORE,
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            isAnchor: true,
            target: '_blank',
          },
          {
            label: ' →',
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            target: '_blank',
          },
        ],
        [
          {
            label: ' ',
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_CALIFORNIA,
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_SOUTHERNCALIFORNIA,
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_GREATERLOSANGELES,
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_NORTHERNCALIFORNIA,
          },
        ],
      ],
      joinUsLink: 'https://join.exprealty.com',
      footerImageData: {
        src: '/next/assets/images/exp-footer-pic-us.jpg',
        alt: LOCALE_EXP_REALTY_US_PATHS.FOOTER_IMAGE_ALT,
      },
    },
    showAccessibilityLink: true,
  };
}